import React from 'react';

import { Arrow } from './Arrow';

import * as styles from './category-tile.module.scss';

export const CategoryTile = ({ category }) => {
  const { title, description, link } = category;
  return (
    <a href={link} className={styles.categoryTile}>
      <h3 className={styles.title}>{title}</h3>
      <p className={styles.description}>
        {description.split('...')[0]}
        <span className={styles.dots}>...</span>
        <span className={styles.hidden}>{description.split('...')[1]}</span>
      </p>
      <p className={styles.link}>
        See posts <Arrow />
      </p>
    </a>
  );
};
